import React from 'react';

const CompletionRangeFilter = ({ filters, updateCompletionFilter }) => {
  return (
    <div>
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-200 mt-4 mb-2">Completion Percentage</h3>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <label htmlFor="min-completion" className="block text-xs text-gray-500 dark:text-gray-400">
            Min (%)
          </label>
          <input
            type="number"
            id="min-completion"
            name="min-completion"
            min="0"
            max="100"
            value={filters.minCompletion}
            onChange={(e) => updateCompletionFilter('minCompletion', e.target.value)}
            className="mt-1 block w-full rounded-md ring-1 ring-inset ring-gray-300 dark:ring-gray-600 py-1.5 px-3 text-sm text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:bg-gray-700"
            placeholder="0"
          />
        </div>
        <div>
          <label htmlFor="max-completion" className="block text-xs text-gray-500 dark:text-gray-400">
            Max (%)
          </label>
          <input
            type="number"
            id="max-completion"
            name="max-completion"
            min="0"
            max="100"
            value={filters.maxCompletion}
            onChange={(e) => updateCompletionFilter('maxCompletion', e.target.value)}
            className="mt-1 block w-full rounded-md ring-1 ring-inset ring-gray-300 dark:ring-gray-600 py-1.5 px-3 text-sm text-gray-900 dark:text-white shadow-sm focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:bg-gray-700"
            placeholder="100"
          />
        </div>
      </div>
    </div>
  );
};

export default CompletionRangeFilter;